import angular from 'angular';
import uiRouter from 'angular-ui-router';

import MenuCatalogComponent from './catalog.component';

import MenuCatalogEditProduct from './edit/edit';

const menuCatalogModule = angular.module('tinaba.components.menu.catalog', [
  uiRouter,
  MenuCatalogEditProduct.name
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('menu.catalog', {
    url: '/catalog',
    template: '<menu-catalog></menu-catalog>'
  });
})

.component('menuCatalog', MenuCatalogComponent);

export default menuCatalogModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/catalog/catalog.js
 **/